import { getSafeApiUrl } from "./urlValidator";

/**
 * Gets API URL from URL parameters
 * @returns API URL from whitelist or null if not found
 */
export const getApiUrl = (): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  const apiUrlFromParams = urlParams.get("apiUrl");
  return getSafeApiUrl(apiUrlFromParams);
};
